export { ColorfulDivider } from './colorful-divider';
